module.exports = __webpack_public_path__ + "static/media/Bn_Favoritos_2021.71d6186b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bn_Favoritos_2021.jpg
// module id = 1463
// module chunks = 0